(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snusify-aplus-header"]) return;
  try {
    
  /* The phone menu closes as a menu should: on Escape, back to its button;
     on a link, which may only scroll this page; and on a tap or focus
     anywhere else. */
  class SnusifyAplusMenu extends HTMLElement {
    #controller = null;

    connectedCallback() {
      const details = this.querySelector('details');
      if (!details) return;

      this.#controller = new AbortController();
      const { signal } = this.#controller;
      const close = (refocus) => {
        if (!details.open) return;
        details.open = false;
        if (refocus) details.querySelector('summary')?.focus();
      };

      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') close(true);
      }, { signal });
      this.addEventListener('click', (event) => {
        if (event.target.closest('a')) close(false);
      }, { signal });
      this.addEventListener('focusout', (event) => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) close(false);
      }, { signal });
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) close(false);
      }, { signal });
    }

    disconnectedCallback() {
      this.#controller?.abort();
    }
  }

  if (!customElements.get('snusify-aplus-menu')) {
    customElements.define('snusify-aplus-menu', SnusifyAplusMenu);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snusify-brands"] && !Shopify.designMode) return;
  try {
    
  /*
   * Puts a brand row's cards into the page the first time the row opens,
   * from the <template> they wait in - or as soon as someone shows they mean
   * to open it: a pointer resting on the row, a press on it, or focus. Then
   * the cans that will be in view once it opens start loading straight away,
   * though the row is still closed and would load nothing by itself. The
   * rest wait, as before, until the rail shows them.
   *
   * <details> fires toggle on itself only, so the list listens in the
   * capture phase.
   */
  const INTENT_MS = 80;

  class SnusifyBrandList extends HTMLElement {
    /** Recreated on every connect: a controller aborted by a disconnect
        cannot be reused. */
    #abort = null;
    #timer = 0;

    connectedCallback() {
      this.#abort?.abort();
      this.#abort = new AbortController();
      const { signal } = this.#abort;

      this.addEventListener(
        'toggle',
        (event) => {
          if (event.target instanceof HTMLDetailsElement && event.target.open) this.unpack(event.target);
        },
        { capture: true, signal }
      );
      this.addEventListener(
        'pointerover',
        (event) => {
          const row = this.#rowOf(event.target);
          if (!row || event.pointerType !== 'mouse') return;
          clearTimeout(this.#timer);
          this.#timer = window.setTimeout(() => this.warm(row), INTENT_MS);
        },
        { signal }
      );
      this.addEventListener(
        'pointerout',
        (event) => {
          const row = this.#rowOf(event.target);
          if (row && !row.querySelector('summary')?.contains(/** @type {Node | null} */ (event.relatedTarget))) {
            clearTimeout(this.#timer);
          }
        },
        { signal }
      );
      this.addEventListener(
        'pointerdown',
        (event) => {
          const row = this.#rowOf(event.target);
          if (row) this.warm(row);
        },
        { signal }
      );
      this.addEventListener(
        'focusin',
        (event) => {
          const row = this.#rowOf(event.target);
          if (row) this.warm(row);
        },
        { signal }
      );

      // A row that was open before the script ran, such as one the editor
      // opened.
      for (const row of this.querySelectorAll('details[open]')) this.unpack(row);
    }

    disconnectedCallback() {
      this.#abort?.abort();
      clearTimeout(this.#timer);
    }

    /**
     * The closed row whose summary an event happened on.
     * @param {EventTarget | null} target
     * @returns {HTMLDetailsElement | null}
     */
    #rowOf(target) {
      const summary = target instanceof Element ? target.closest('summary') : null;
      const row = summary?.parentElement;
      return row instanceof HTMLDetailsElement && !row.open && this.contains(row) ? row : null;
    }

    /** @param {HTMLDetailsElement} row */
    unpack(row) {
      const cards = row.querySelector('template[data-brand-cards]');
      cards?.replaceWith(cards.content);
    }

    /**
     * Unpack a row before it opens and start loading the cans its rail will
     * show first: as many as the rail fits across, rounded up.
     * @param {HTMLDetailsElement} row
     */
    warm(row) {
      this.unpack(row);
      const track = row.querySelector('[data-rail-track]');
      if (!track) return;
      const across = Math.ceil(parseFloat(getComputedStyle(track).getPropertyValue('--snusify-rail-visible')) || 1);
      for (const img of [...track.querySelectorAll('.snusify-product__art img')].slice(0, across)) {
        if (img instanceof HTMLImageElement && img.loading === 'lazy') img.loading = 'eager';
      }
    }
  }

  if (!customElements.get('snusify-brand-list')) {
    customElements.define('snusify-brand-list', SnusifyBrandList);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snusify-collection-hero"]) return;
  try {
    
  /*
   * The phone's folded description works without this (see the stylesheet).
   * It hides the toggle when the text fits in the fold anyway - a short
   * description on a wider phone - and opens the fold when a link inside the
   * hidden part takes focus, so nothing is focused out of sight.
   */
  class SnusifyLede extends HTMLElement {
    /** Recreated on every connect: a controller aborted by a disconnect
        cannot be reused. */
    #abort = null;
    #observer = null;
    #width = -1;

    connectedCallback() {
      this.#abort?.abort();
      this.#abort = new AbortController();
      const text = this.querySelector('.snusify-lede__text');
      const toggle = this.querySelector('.snusify-lede__toggle');
      if (!text || !(toggle instanceof HTMLDetailsElement)) return;

      this.addEventListener(
        'focusin',
        (event) => {
          if (text.contains(/** @type {Node} */ (event.target))) toggle.open = true;
        },
        { signal: this.#abort.signal }
      );

      // The width decides how many lines the text takes. Measured on the next
      // frame, since data-fits resizes the box being observed.
      this.#observer?.disconnect();
      this.#observer = new ResizeObserver(([entry]) => {
        if (entry.contentRect.width === this.#width) return;
        this.#width = entry.contentRect.width;
        requestAnimationFrame(() => this.measure());
      });
      this.#observer.observe(text);

      // A web font arriving late can change the count of lines too.
      document.fonts?.ready.then(() => this.measure());
    }

    disconnectedCallback() {
      this.#abort?.abort();
      this.#observer?.disconnect();
      this.#width = -1;
    }

    /**
     * Whether the text fits in the fold, compared with the fold's own height
     * rather than the box's, so the answer is the same open or folded.
     */
    measure() {
      const text = this.querySelector('.snusify-lede__text');
      if (!text?.isConnected) return;
      const style = getComputedStyle(text);
      const lines = parseFloat(style.getPropertyValue('--snusify-lede-lines'));
      const leading = parseFloat(style.lineHeight);
      if (!lines || !leading) return;
      this.toggleAttribute('data-fits', text.scrollHeight <= Math.ceil(lines * leading));
    }
  }

  if (!customElements.get('snusify-lede')) {
    customElements.define('snusify-lede', SnusifyLede);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snusify-withdrawal"] && !Shopify.designMode) return;
  try {
    
  /*
   * Keeps what the buyer sends, and when, in this tab, and shows it once the
   * store has it, so it can be printed or saved; then forgets it. Only the
   * visible fields are kept, by their own labels.
   */
  (() => {
    const KEY = 'snusify-withdrawal';

    for (const form of document.querySelectorAll('[data-withdrawal-form]')) {
      form.addEventListener('submit', () => {
        const sent = [];
        for (const field of form.querySelectorAll('input:not([type="hidden"]), textarea')) {
          const label = form.querySelector(`label[for="${CSS.escape(field.id)}"]`);
          const name = label?.firstChild?.textContent?.trim();
          if (name && field.value.trim()) sent.push([name, field.value.trim()]);
        }
        try {
          sessionStorage.setItem(KEY, JSON.stringify({ at: new Date().toISOString(), sent }));
        } catch {
          // Without storage the confirmation just leaves the summary out.
        }
      });
    }

    const done = document.querySelector('[data-withdrawal-done]');
    const problem = document.querySelector('[data-withdrawal-errors]');
    (done ?? problem)?.focus();
    if (!done) return;

    let kept = null;
    try {
      kept = JSON.parse(sessionStorage.getItem(KEY) ?? 'null');
      sessionStorage.removeItem(KEY);
    } catch {
      kept = null;
    }

    const at = new Date(kept?.at ?? '');
    const time = done.querySelector('[data-withdrawal-time]');
    if (time && !Number.isNaN(at.getTime())) {
      time.dateTime = at.toISOString();
      time.textContent = new Intl.DateTimeFormat(document.documentElement.lang || undefined, {
        dateStyle: 'long',
        timeStyle: 'short',
      }).format(at);
    }

    const sent = kept?.sent;
    const list = done.querySelector('[data-withdrawal-list]');
    if (!list || !Array.isArray(sent) || sent.length === 0) return;
    for (const [name, value] of sent) {
      const term = document.createElement('dt');
      term.textContent = String(name);
      const detail = document.createElement('dd');
      detail.textContent = String(value);
      list.append(term, detail);
    }
    done.querySelector('[data-withdrawal-summary]')?.removeAttribute('hidden');
  })();

  } catch(e) { console.error(e); }
})();
})();
